<div class="cmn-flex row padded-bottom">
    <mat-card class="flex">
            <app-autocomplete #autoComplete (autocompleteInput)="onGroupChanged($event)" (loadRequest)="load($event)" (selection)="selectGroup($event)" (filterChange)="load($event)"
                              [label]="'Search for a Group'" [hint]="'Search by ID or Name'" [objects]="autocompleteGroups"
                              [filterConfig]="filterConfig" [buttonConfig]="buttonConfig" (addRequest)="newGroup()" [disabled]="!fullReady"
                              [options]="autocompleteGroupsFormatted" [page]="pageNum" [searchName]="'Group'" id="selectGroup"></app-autocomplete>
    </mat-card>
</div>
<div *ngIf="!showSpinner && !selectedGroup">
    <app-grid #grid
              (activate)="onActivate($event)"
              (pageChange)="pageCallback($event)"
              (sortChange)="sortCallback($event)"
              (filterChange)="filterChange($event)"
              [filter]="onlyShowOwnedGroups"
              [filterToggle]="showGroupFilter"
              [filterDesc]="'Only Show Groups You Own'"
              [headers]="header"
              [width]="width"
              [rows]="groupList"
              [page]="page"
              [showDeactiveIcon]="true"
              id="grid"></app-grid>
</div>
<mat-card *ngIf="showDetailsPage" class="cmn-flex row">
    <div class="cmn-flex row gutters-lg">
        <label *ngIf="this.selectedGroup.id">
            {{!selectedGroup.name ? '--' : selectedGroup.name}}
        </label>
        <label *ngIf="this.selectedGroup.id">
            Alerting ID: {{!selectedGroup.id ? '--' : selectedGroup.id}}{{selectedGroup.active ? '' : ' - (DEACTIVATED - AWAITING DELETION)'}}
        </label>
        <label *ngIf="!this.selectedGroup.id">New Group - {{selectedGroup.name}}</label>
        <div class="flex align-top">
        <mat-button *ngIf="!isEditable()" (click)="openGroupEditFAQ()"  color="primary" id="openGroupFAQ" mat-icon-button
                    matTooltip="Why can't I edit this?" class="gutters align-baseline">
            <mat-icon class="align-baseline" color="primary">lock</mat-icon>
        </mat-button>
        <mat-button *ngIf="isEditable()" (click)="openGroupEditFAQ()"  color="primary" id="openGroupFAQ" mat-icon-button
                        matTooltip="What is ownership?" class="gutters align-baseline">
                <mat-icon class="align-top" color="primary">lock_open</mat-icon>
        </mat-button>
        </div>
        <div *ngIf="selectedGroup.id && (isAdmin || isOwner || selectedGroup.open_group) && selectedGroup.group_type.toUpperCase().includes('ON CALL')"
         id="selectedGroupId" class="flex">
            <button (click)="changeOnCall()" [disabled]="isProcessing" color="primary" id="changeOncallbtn" mat-raised-button>Set On Call
                <div [ngClass]="checkmark"></div>
            </button>
            <label *ngIf="selectedGroup.group_type_id===2">&nbsp;to {{currentUser.full_name}}</label>
        </div>
        <mat-slide-toggle (change)="activateGroup()" *ngIf="selectedGroup.id && (isOwner || isAdmin)" [ngModel]="selectedGroup.active"
                          [disabled]="isProcessing || selectedGroup.active" aria-hidden="false" aria-label="Active"
                          color="primary" id="activeGroup" matTooltip="Set group active status"></mat-slide-toggle>
        <button (click)="deleteGroup()" *ngIf="selectedGroup.id && isEditable()" [disabled]="isProcessing || !selectedGroup.active" aria-label="Delete Group Button"
            color="primary" id="deleteGroupIcon" mat-icon-button>
        <mat-icon class="padded-left-lg padded-bottom-lg">delete</mat-icon>
        </button>
        <button (click)="closeGroup()"  aria-label="Close Group Button" color="primary" id="closeGroupIcon" mat-icon-button>
            <mat-icon class="padded-left-lg padded-bottom-lg">close</mat-icon>
        </button>
    </div>
    <mat-tab-group>
        <mat-tab label="Details">
            <mat-card>
                <mat-card-content>
                    <div class="cmn-flex row padded-top padded-bottom gutters">
                        <mat-form-field class="flex">
                            <input [(ngModel)]="selectedGroup.name"
                                   (ngModelChange)="updateGroupName()"
                                   (change)="isValid()"
                                   id="groupName" matInput
                                   name="groupName"
                                   type="text"
                                   [disabled]="isProcessing"
                                   [readonly]="!isEditable()"
                                   placeholder="Name"
                                   required>
                            <mat-error *ngIf="!groupNameValid">Group must have a name.</mat-error>
                        </mat-form-field>
                        <mat-form-field class="flex">
                            <input [(ngModel)]="selectedGroup.device_name"
                                   [disabled]="true" matInput
                                   placeholder="Device Name">
                            <mat-hint>"For use by mainframe paging"</mat-hint>
                        </mat-form-field>
                        <mat-form-field class="flex">
                            <mat-select [(value)]="selectedGroup.group_type_id"
                                        (selectionChange)="updateGroupType()"
                                        [disableOptionCentering]="true"
                                        id="selectGroupType"
                                        [disabled]="isProcessing || !isEditable()"
                                        placeholder="Type"
                                        required>
                                <mat-option *ngFor="let gtype of groupTypes" [value]="gtype.group_type_id"
                                            id="{{gtype.group_type}}" matTooltip="{{gtype.group_type_desc}}">{{ gtype.group_type }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="!groupTypeValid" id="InvalidgroupType">Group must have a
                                type.
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="cmn-flex row gutters padded-top-lg">
                        <mat-label class="padded-right-sm">Escalate:</mat-label>
                        <div>
                            <mat-radio-group [(ngModel)]="escalationRadioButton"
                                             [disabled]="!isEditable()"
                                             #radioGroup="matRadioGroup"
                                             id="escalationRadioGroup"
                                             name="RadioGroup">
                                <div class="cmn-flex row gutters">
                                    <mat-radio-button (change)="updateEscalateTo($event)"
                                                      [disabled]="isProcessing"
                                                      color="primary" id="GroupSelection" matTooltip="Group"
                                                      value="GROUP"
                                    >
                                        Group
                                    </mat-radio-button>
                                    <mat-radio-button (change)="updateEscalateTo($event)" [disabled]="isProcessing"
                                                      color="primary"
                                                      id="IndividualSelection" matTooltip="Individual"
                                                      value="INDIVIDUAL"
                                    >
                                        Individual or Channel
                                    </mat-radio-button>
                                    <mat-radio-button
                                        (change)="updateEscalateTo($event); getAutocompleteEscalate('Do Not Escalate')"
                                        [disabled]="isProcessing" color="primary"
                                        id="doNotEscalate" matTooltip="Do Not Escalate" value="Do Not Escalate"
                                    >
                                        Do Not Escalate
                                    </mat-radio-button>
                                    <mat-button (click)="openGroupEscalationFAQ()" color="primary" id="openEscalationFAQ" mat-icon-button
                                                matTooltip="What is escalation?" class="gutters align-baseline">
                                        <mat-icon class="align-baseline" color="primary">help</mat-icon>
                                    </mat-button>
                                </div>
                            </mat-radio-group>

                        </div>
                        <div class="cmn-flex flex row gutters">
                            <mat-chip-list #escalateChipList
                                           [hidden]="escalationRadioButton === 'Do Not Escalate'">
                                <mat-chip (click)="openPopup(escalates)" (removed)="removeEscalateChip(escalates)" [disabled]="isProcessing"
                                          *ngFor="let escalates of escalateToChipList">{{ escalates }}
                                    <mat-icon *ngIf="isEditable()" matChipRemove>cancel</mat-icon>
                                </mat-chip>
                            </mat-chip-list>
                            <mat-form-field
                                [hidden]="escalationRadioButton === 'Do Not Escalate' || escalateToChipList.length > 0" class="flex">
                                <input [(ngModel)]="currentEscalation" (ngModelChange)="onEscalateToChanged($event)"
                                       [disabled]="isProcessing"
                                       [matAutocomplete]="autoIndividual"
                                       [matChipInputFor]="escalateChipList"
                                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes" id="escalateNameSelection" matInput name="escalate" [required]="escalationRadioButton !== 'Do Not Escalate'">
                                <mat-autocomplete #autoIndividual="matAutocomplete"
                                                  (optionSelected)="selectGroupEscalate($event.option.value)"
                                                  id="displayIdList">
                                    <mat-option *ngFor="let option of autocompleteEscalate; let i = index" [value]="option"
                                                id="displayIdSelection{{i}}">{{option.name ? option.name : option.full_name}} <span
                                        *ngIf="displayId"> ({{ option.name ? option.id : option.external_id }}) </span>
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-hint *ngIf="escalateValid" [className]="escalationRadioButton === 'Do Not Escalate' ? 'white' : ''">Search for a
                                    <span *ngIf="escalationRadioButton === 'GROUP'"
                                          style="text-transform: lowercase;">{{escalationRadioButton}} </span>
                                    <span *ngIf="escalationRadioButton !== 'GROUP'" style="text-transform: lowercase;">{{escalationRadioButton}}
                                        & Channel</span> by name.
                                </mat-hint>
                                <mat-error *ngIf="!escalateValid" id="escalateInValid">Please select a valid value for <span
                                    *ngIf="escalationRadioButton === 'GROUP'"
                                    style="text-transform: lowercase;">{{escalationRadioButton}} </span>
                                    <span *ngIf="escalationRadioButton !== 'GROUP'" style="text-transform: lowercase;">{{escalationRadioButton}}
                                        & Channel.</span>
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="cmn-flex row align-baseline gutters padded-top">
                        <mat-form-field class="flex">
                            <mat-label>Escalation Frequency</mat-label>
                            <input [(ngModel)]="selectedGroup.escalate_time_limit"
                                   (keypress)="onTimeLimitKeyPress($event)"
                                   (ngModelChange)="escalateTimeChange()"
                                   (paste)="onTimeLimitPaste($event)"
                                   [readonly]="!isEditable() || groupTypeUsesSystemOverride"
                                   [required]="escalationRadioButton !== 'Do Not Escalate' && isEditable()"
                                   [matTooltipDisabled]="!groupTypeUsesSystemOverride"
                                   matTooltip="The {{selectedGroup.group_type}} group type does not allow custom escalation intervals"
                                   id="escalationFrequency" matInput max="99" min="1"
                                   name="escalate_time_limit"
                                   type="number"
                                   placeholder="Escalates Every">
                            <mat-hint>Minutes</mat-hint>
                            <mat-error *ngIf="!escalateTimeValid">Frequency must be 0-99</mat-error>
                        </mat-form-field>
                        <mat-form-field class="flex">
                            <input [(ngModel)]="selectedGroup.reminder_time_limit"
                                   (keypress)="onTimeLimitKeyPress($event)"
                                   (ngModelChange)="reminderTimeChange()"
                                   (paste)="onTimeLimitPaste($event)" [readonly]="!isEditable() || groupTypeUsesSystemOverride"
                                   [required]="escalationRadioButton !== 'Do Not Escalate' && isEditable()"
                                   [matTooltipDisabled]="!groupTypeUsesSystemOverride"
                                   matTooltip="The {{selectedGroup.group_type}} group type does not allow custom reminder intervals"
                                   id="reminderFrequency" matInput max="99" min="1"
                                   name="reminder_time_limit"
                                   type="number"
                                   placeholder="Reminder Frequency">
                            <mat-hint>Minutes 1-99</mat-hint>
                            <mat-error *ngIf="!reminderTimeValid">Frequency must be 0-99</mat-error>
                        </mat-form-field>
                        <mat-form-field class="flex">
                            <input [(ngModel)]="selectedGroup.ack_required_percentage"
                                   (keypress)="onTimeLimitKeyPress($event)"
                                   (ngModelChange)="ackRequiredChange()"
                                   (paste)="onTimeLimitPaste($event)"
                                   [disabled]="isProcessing"
                                   [readOnly]="!isEditable()"
                                   [required]="escalationRadioButton !== 'Do Not Escalate' && isEditable()"
                                   id="group_percent"
                                   matInput max="100" min="1"
                                   name="group_percent" type="number"
                                   placeholder="Acknowledgment %">
                            <mat-error *ngIf="!ackRequiredValid">Percentage must be 1-100</mat-error>
                        </mat-form-field>
                        <mat-checkbox *ngIf="showAckRequired"
                                      [(ngModel)]="selectedGroup.ack_required"
                                      (ngModelChange)="saveButtonDisabled = false"
                                      [disabled]="(isEditable() && isProcessing) || isAckNotRequired(selectedGroup)"
                                      labelPosition="before"
                                      id="ackCheckbox"
                                      matTooltip="This feature is being deprecated. Once disabled, it cannot be re-enabled."
                                      name="ackCheckbox"
                        >Acknowledgment Required:
                        </mat-checkbox>
                    </div>
                    <div class="cmn-flex flex row gutters padded-top-lg padded-bottom-lg">
                        <mat-label class="padded-top-lg">Owners:</mat-label>
                        <mat-form-field class="flex">
                            <mat-chip-list #ownerChipList>
                                <mat-chip (click)="openPopup(owner)"
                                      (removed)="removeGroupOwner(owner)"
                                      [disabled]="isProcessing"
                                      *ngFor="let owner of selectedGroup.owners">{{owner.full_name}}
                                        <mat-icon *ngIf="isEditable()" matChipRemove>cancel</mat-icon>
                                </mat-chip>

                                <mat-autocomplete #autoGroupOwner="matAutocomplete" (optionSelected)="groupOwnerSelect($event, groupOwner)" (optionSelected)="isValid()"
                                                  [displayWith]="''" id="matAutocomplete">
                                    <mat-option *ngFor="let groupOwner of autocompleteGroupOwners" [value]="groupOwner"
                                                id="groupOwnerAutoSelection">{{ groupOwner.full_name }}
                                        ({{ groupOwner.external_id }})
                                    </mat-option>
                                </mat-autocomplete>
                                <input [(ngModel)]="currentGroupOwner" #groupOwner
                                       (ngModelChange)="onGroupOwnerChanged($event)"
                                       [matAutocomplete]="autoGroupOwner"
                                       [matChipInputFor]="ownerChipList"
                                       [disabled]="isProcessing || !isEditable()"
                                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes" id="group-owner" matInput name="group-owner"
                                       required>
                            </mat-chip-list>
                            <mat-hint *ngIf="groupOwnersValid" id="groupOwnersValid">Search for an individual by last name</mat-hint>
                            <mat-error *ngIf="!groupOwnersValid" id="groupOwnersValidError">You must
                                include a group owner
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="cmn-flex row padded-top-lg padded-bottom-lg">
                        <mat-radio-group [(ngModel)]="selectedGroup.sub_group_enabled" class="cmn-flex flex row gutters-sm"
                                         id="subGroupRadioGroup" name="subGroupRadioGroup" [disabled]="isProcessing">
                            <mat-label>Membership Type: </mat-label>
                            <mat-radio-button color="primary" [disabled]="!isEditable()"
                                              id="IndividualMembers" name="individualMembers" matTooltip="Individuals/Channels" [value]="false">
                                Individuals & Channels
                            </mat-radio-button>
                            <mat-radio-button color="primary" [disabled]="!isEditable()" (change)="setSelfSubToFalse()"
                                              id="GroupMembers" name="groupMembers" matTooltip="Groups" [value]="true">
                                Groups
                            </mat-radio-button>
                        </mat-radio-group>
                        <div class="cmn-flex row gutters-sm">
                            <mat-label>Allow Self-subscription: </mat-label>
                            <mat-slide-toggle [(ngModel)]="selectedGroup.open_group" (ngModelChange)="saveButtonDisabled = false"
                                              [disabled]="isProcessing || !isEditable() || selectedGroup.sub_group_enabled" class="align-top" color="primary" id="Self-subscription-toggle"></mat-slide-toggle>
                        </div>
                    </div>
                    <div *ngIf="!isEditable()" class="cmn-flex row gutters">
                        <mat-label *ngIf="selectedGroup.sub_group_enabled">Group Members:</mat-label>
                        <mat-label *ngIf="!selectedGroup.sub_group_enabled">Individual Members:</mat-label>
                        <div *ngIf="selectedGroup.open_group && selectedGroup.active && currentUser">
                            <button (click)="addCurrentUser();" [disabled]="isProcessing" *ngIf="!isCurrentMember" color="primary" id="addMe" mat-raised-button>Add me
                                <mat-icon>add</mat-icon>
                            </button>
                            <button (click)="removeCurrentUser();" [disabled]="isProcessing" *ngIf="isCurrentMember" color="primary" id="removeMe" mat-raised-button>Remove me
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <mat-chip-list aria-orientation="horizontal">
                            <mat-chip (click)="openPopup(member)" *ngFor="let member of selectedGroup.members">{{ member.name }}</mat-chip>
                        </mat-chip-list>
                    </div>
                    <app-recipients *ngIf="isEditable()"
                                    [(recipients)]="selectedGroup.members"
                                    [needsAck]="false"
                                    [showGroupField]="selectedGroup.sub_group_enabled"
                                    [disableEditing]="isProcessing"
                                    [showIndividualField]="!selectedGroup.sub_group_enabled"
                                    [showPhoneField]="false"
                                    (recipientsChange)="saveButtonDisabled = false">
                    </app-recipients>
                    <div *ngIf="members !== undefined && selectedGroup.id && members.length > 0" class="cmn-flex row gutters padded-top-lg">
                        <mat-label>Member Of:</mat-label>
                        <mat-chip-list>
                            <mat-chip (click)="openGroupPopup(member.id)" *ngFor="let member of members">{{ member.name }}</mat-chip>
                        </mat-chip-list>
                    </div>
                </mat-card-content>
                <mat-card-actions>
                    <div *ngIf="isEditable()" class="cmn-flex space-between">
                        <app-spinner-button (buttonClick)="saveGroup()"
                                            [disabled]="isSaveButtonDisabled()"
                                            [processing]="isProcessing"
                                            buttonText="Save"
                                            [matTooltip]="getSaveButtonTooltip()"
                                            color="primary">
                        </app-spinner-button>
                        <app-spinner-button (buttonClick)="cancel()"
                                            [processing]="isProcessing"
                                            buttonText="Cancel"
                                            color="primary">
                        </app-spinner-button>
                    </div>
                </mat-card-actions>
            </mat-card>
        </mat-tab>
        <mat-tab *ngIf="selectedGroup.id" id="Schedule" label="Schedule">
            <mat-card>
                <div class="cmn-flex row gutters-lg padded-bottom-md">
                    <mat-label class="align-baseline">Notify With Schedule Rotation:</mat-label>
                    <div class="flex">
                            <mat-radio-group [(ngModel)]="notificationRadioButton" [disabled]="isProcessing" #radioGroup="matRadioGroup"
                                             id="notificationRadioButtons"
                                             name="RadioGroup2">
                                <div class="cmn-flex row gutters">

                                    <mat-radio-button (change)="updateNotificationTo($event)" [disabled]="!isEditable()" color="primary"
                                                      id="scheduleGROUP" matTooltip="Group"
                                                      value="GROUP">Group</mat-radio-button>
                                    <mat-radio-button (change)="updateNotificationTo($event)" [disabled]="!isEditable()" color="primary"
                                                      id="scheduleIndividual" matTooltip="Individual"
                                                      value="INDIVIDUAL">Individuals &
                                        Channels
                                    </mat-radio-button>
                                    <mat-radio-button (change)="updateNotificationTo($event); getAutocompleteNotify('Do Not Notify')"
                                                      [disabled]="!isEditable()" color="primary"
                                                      id="Do Not Notify" matTooltip="No Notification" value="Do Not Notify">Do Not Notify
                                    </mat-radio-button>
                                </div>
                            </mat-radio-group>
                    </div>
                    <div class="cmn-flex flex row gutters">
                        <mat-chip-list #notifyChipList >
                            <mat-chip (click)="openPopup(notify)" (removed)="removeNotifyChip(notify)"
                                      [disabled]="isProcessing" *ngFor="let notify of notificationToChipList">{{notify}}
                                <mat-icon *ngIf="isEditable()" matChipRemove>cancel</mat-icon>
                            </mat-chip>
                        </mat-chip-list>
                        <mat-form-field
                            *ngIf="isEditable() && notificationRadioButton !== 'Do Not Notify' && notificationToChipList.length === 0"
                            class="flex">
                            <input [(ngModel)]="currentNotificationTo" (ngModelChange)="onNotificationToChanged($event)"
                                   [matAutocomplete]="autoNotify" [matChipInputFor]="notifyChipList" [disabled]="isProcessing"
                                   [matChipInputSeparatorKeyCodes]="separatorKeysCodes" id="autoNotify" matInput name="notify">
                            <mat-autocomplete #autoNotify="matAutocomplete" (optionSelected)="selectGroupNotify($event.option.value)"
                                              id="selectGroupNotify">
                                <mat-option *ngFor="let option of autocompleteNotificationTo; let i = index" [value]="option"
                                            id="notificationToDisplayId{{i}}">
                                    {{option.name ? option.name : option.full_name }}
                                    <span *ngIf="displayId"> ({{ option.name ? option.id : option.external_id }}) </span>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div *ngIf="isEditable()" class="cmn-flex space-between row gutters">
                        <button (click)="updatePopup()" [disabled]="isProcessing" id="editManageSchedule" color="primary" mat-raised-button>
                            <span>Manage Schedule</span>
                            <mat-icon class="padded-left">edit</mat-icon>
                        </button>
                    </div>
                </div>
                <app-scheduler [currentGroup]="selectedGroup"></app-scheduler>
                <mat-card-actions>
                    <div *ngIf="isEditable()" class="cmn-flex space-between">
                        <app-spinner-button (buttonClick)="saveGroup()"
                                            [disabled]="isSaveButtonDisabled()"
                                            [processing]="isProcessing"
                                            buttonText="Save"
                                            [matTooltip]="isSaveButtonDisabled() ? saveButtonTooltip : null"
                                            color="primary">
                        </app-spinner-button>
                        <app-spinner-button (buttonClick)="cancel()"
                                            [processing]="isProcessing"
                                            buttonText="Cancel"
                                            color="primary">
                        </app-spinner-button>
                    </div>
                </mat-card-actions>
            </mat-card>
        </mat-tab>
    </mat-tab-group>

</mat-card>
<app-hourglass *ngIf="showSpinner"></app-hourglass>
